function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { DATE_MASK_VALUE as A, DATE_MASK_RANGE_VALUE as l, SHORT_SEPARATOR_POSITIONS as u, LONG_SEPARATOR_POSITIONS as h } from "./index.es652.js";
import { usePreserveCaretPosition as P } from "./index.es687.js";
import { inputPositionStats as _, applyCaretPosition as m } from "./index.es688.js";

var f = function f(_ref) {
  var n = _ref.stateValues,
      S = _ref.setInputValue,
      r = _ref.inputRef;
  var g = P(r);
  return function (s) {
    var _n$;

    var t = _(r, ((_n$ = n[0]) === null || _n$ === void 0 ? void 0 : _n$.length) === A.length ? n.join(" — ") : n[0], s);

    var e = s;
    t.isDeleteSingleDash && (e = e.slice(0, t.selectionStart - 1) + e.slice(t.selectionStart)), t.isDeleteSingleLongDash && (e = e.slice(0, t.selectionStart - 3) + e.slice(t.selectionStart)), e = e.replaceAll(/[^0-9]/g, ""), e = _toConsumableArray(e).reduce(function (i, o) {
      return l.length === i.length ? i : u.includes(i.length + 1) ? "".concat(i).concat(o, "-") : h.includes(i.length + 1) ? "".concat(i).concat(o, " \u2014 ") : i + o;
    }, ""), t.isSingleCursor && t.selectionStart === l.length && requestAnimationFrame(function () {
      var _r$current;

      return (_r$current = r.current) === null || _r$current === void 0 ? void 0 : _r$current.blur();
    }), m(t, g), S(e);
  };
};

export { f as useChangeInput };